import React from 'react'
import { Space, Divider } from 'antd'
import Title from '../../system/title/Title';

type SectionProps = {
    title: string,
    subTitle?: string,
    children: React.ReactNode,
}

const Section: React.FunctionComponent<SectionProps> = ({
    children,
    title,
    subTitle
}) => {
    return (
        <Space style={{ width: '100%' }} direction="vertical">
            <div>
                <Title
                    title={title}
                    subTitle={subTitle}
                />
                <Divider style={{margin:"15px 0px"}} />
            </div>
            {children}
        </Space>
    )
}

export default Section
